/* src/app/candidate-form/candidate-form.component.scss */
.candidateOffer {
  background-image: url("./media/candidate-bg.jpg");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}
.job-date-expired {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.55;
  filter: grayscale(0.15);
}
.job-date-expired .btn-success {
  cursor: not-allowed;
}
.link-expired-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 1.5rem;
  box-sizing: border-box;
}
.link-expired-card {
  max-width: 420px;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  padding: 2.5rem 2rem;
  text-align: center;
}
.link-expired-icon {
  margin-bottom: 1.25rem;
}
.link-expired-icon mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #00a1b1;
}
.link-expired-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.75rem;
}
.link-expired-message {
  font-size: 1.05rem;
  color: #444;
  margin: 0 0 0.5rem;
  line-height: 1.5;
}
.link-expired-sub {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}
.icon-box {
  background: rgba(0, 162, 178, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;
  color: #00a2b2;
}
@media (max-width: 576px) {
  .link-expired-card {
    padding: 1.75rem 1.25rem;
  }
  .link-expired-title {
    font-size: 1.5rem;
  }
  .link-expired-icon mat-icon {
    font-size: 52px;
    width: 52px;
    height: 52px;
  }
}
.candidateOffer .candidate_Details {
  width: 70%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 100%;
  border: 0px;
  border-radius: 12px;
}
.candidate_Details2 {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.03);
  border: 0;
  border-radius: 12px;
}
.sub-text {
  display: block;
  margin-top: 0px;
  color: rgba(19, 23, 32, 0.8);
  font-size: 17px;
  margin-bottom: 0px;
  padding: 3px 11px;
  font-weight: 500;
}
.candidate_Details h2 {
  padding: 3px 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 500;
}
.TopHeading {
  margin-bottom: 30px;
}
.TopHeading h4 {
  text-align: center;
  font-weight: 500;
  margin-bottom: 0;
  font-size: 25px;
  color: #000;
}
.candidateOffer .mat-mdc-card-header {
  display: flex;
  padding: 25px 25px 0;
}
.material {
  margin-bottom: 30px;
}
.midHeading {
  color: rgb(106, 113, 129);
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0px;
}
.paraTesting {
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  color: #585858;
}
.file-upload {
  position: relative;
  margin-left: 8px;
  margin: 60px;
}
.file-upload-label {
  cursor: pointer;
}
.downloadButton {
  border: 1px solid #00a1b1;
  color: #00a2b2 !important;
  font-weight: 500;
  font-size: 13px;
  border-radius: 8px;
  padding: 14px;
  padding-top: 12px;
  letter-spacing: 0.5px;
}
.downloadButton mat-icon {
  color: #00a2b2 !important;
}
.candidate_Details .mdc-card__actions {
  display: flex;
  justify-content: space-between !important;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.card-actions-wrap {
  flex-wrap: wrap;
}
.file-upload-container {
  display: inline-block;
  padding: 8px 10px;
  border: 2px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.placeholder-text {
  color: #888;
}
.file-name {
  margin-left: 18px;
}
.applyButton {
  background-color: #00a2b2;
  color: #fff !important;
  border-radius: 8px;
  padding: 3px 15px;
  margin-left: 0px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.icon-box mat-icon {
  font-size: 23px;
  width: 23px;
  height: 23px;
}
.form-card {
  margin-top: 10px;
  margin-bottom: 25px;
  padding: 15px 10px;
}
.form-card h3 {
  margin-left: 15px;
  margin-bottom: 16px;
  margin-top: 8px;
  font-weight: 500;
  color: #00a2b2;
}
.answereArea {
  background-color: #ffffff;
  padding: 20px 27px;
  border-radius: 5px;
}
.table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
}
th,
td {
  padding: 12px;
  text-align: left;
}
th {
  background-color: #ffffff;
  font-weight: 500;
}
.table > thead,
.table > tbody {
  vertical-align: middle;
}
.mat-card {
  margin-top: 20px;
}
.readonly-wrapper {
  pointer-events: none;
}
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-form-field-focus-overlay {
  border-color: #f44336;
}
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
.file-input-resp.file-input-error {
  border: 2px solid #f44336;
  border-radius: 4px;
}
.saveCss {
  padding: 10px;
  background: gray;
  color: white;
  border-radius: 5px solid none;
  border-radius: 6px;
  border: none;
}
.imgEmp {
  width: 40px;
  height: 31px;
  position: relative;
  top: -32px;
  left: 40%;
  border-radius: 5px;
  cursor: pointer;
  color: black;
}
.codeArea {
  position: relative;
}
.codeArea .addCoding {
  position: absolute;
  top: 20px;
  left: 0px;
  z-index: 999;
  width: 65px;
}
.codeArea .mat-mdc-form-field {
  margin-bottom: 0px;
  padding: 0;
}
.codeArea .mat-mdc-input-element {
  padding-left: 80px;
}
.country-codes {
  width: 128%;
  max-width: 120px;
}
.country-search {
  width: 80px;
}
.responsive-table {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
::ng-deep .form-group mat-label {
  font-size: 13px;
  color: #6a7181;
}
:host ::ng-deep .mdc-text-field--filled {
  background: transparent !important;
}
.candidateOffer ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {
  padding-top: 15px !important;
}
.candidateOffer ::ng-deep .mat-mdc-select-trigger {
  margin-top: 1px !important;
}
@media (max-width: 1024px) {
  .candidateOffer .candidate_Details {
    width: 90%;
  }
  .TopHeading h4 {
    font-size: 22px;
  }
  .candidateOffer .mat-mdc-card-header {
    padding: 20px 15px 0;
  }
  .form-card {
    padding: 15px 12px;
  }
  .answereArea {
    padding: 16px 20px;
  }
  .questions-table {
    min-width: 100%;
  }
}
@media (max-width: 768px) {
  .candidateOffer .candidate_Details {
    width: 95%;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .TopHeading h4 {
    font-size: 20px;
  }
  .midHeading {
    font-size: 17px;
  }
  .candidateOffer .mat-mdc-card-header {
    padding: 15px 12px 0;
    flex-direction: column;
    align-items: stretch;
  }
  .candidate_Details .mdc-card__actions {
    flex-direction: column;
    align-items: stretch;
    padding: 15px !important;
  }
  .candidate_Details .mdc-card__actions .applyButton {
    margin-left: 0;
  }
  .form-card {
    padding: 12px 10px;
    margin-bottom: 24px;
  }
  .form-card h3 {
    margin-left: 10px;
    font-size: 1.1rem;
  }
  .answereArea {
    padding: 14px 12px;
  }
  .answereArea p {
    font-size: 16px;
  }
  .responsive-table {
    overflow-x: visible;
  }
  .questions-table thead {
    display: none;
  }
  .questions-table tbody tr {
    display: block;
  }
  .questions-table tbody tr.question-row {
    display: block;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    background: #fff;
  }
  .questions-table tbody tr.save-row {
    display: block;
    border: none;
    box-shadow: none;
    background: transparent;
    padding: 20px 0 8px;
    margin-bottom: 0;
  }
  .questions-table td {
    display: block;
    text-align: left;
    padding: 16px 0 14px;
    padding-left: 0;
    padding-right: 0;
    padding: 10px;
    border: none !important;
    border-bottom: 1px solid #f3f4f6 !important;
  }
  .questions-table tr.question-row td:first-child {
    padding-top: 0;
  }
  .questions-table tr.question-row td:last-child {
    border-bottom: none !important;
    padding-bottom: 0;
  }
  .questions-table td::before {
    content: attr(data-label);
    font-weight: 600;
    font-size: 12px;
    color: #4b5563;
    display: block;
    margin-bottom: 10px;
  }
  .questions-table td.answer-cell::before {
    margin-bottom: 12px;
  }
  .questions-table td.save-cell::before {
    display: none;
  }
  .questions-table .save-cell {
    text-align: center !important;
    border: none !important;
    padding: 16px 0 0 !important;
  }
  .questions-table .save-cell .applyButton {
    min-width: 140px;
    min-height: 44px;
    padding: 10px 32px;
  }
  .questions-table .mat-mdc-form-field {
    width: 100%;
    margin-top: 4px;
  }
  .questions-table .custom-answer-field {
    width: 100%;
    margin-top: 12px;
  }
  .codeArea .addCoding {
    width: 75px;
  }
  .codeArea .addCoding .country-codes {
    max-width: 100px;
  }
  .codeArea .mat-mdc-input-element {
    padding-left: 68px;
  }
  .file-input-resp {
    padding-right: 12px;
    font-size: 13px;
  }
  .downloadButton {
    width: 100%;
  }
  .table {
    border: 0 !important;
  }
  .candidate_Details h2 {
    font-size: 18px;
  }
  .icon-box {
    padding: 7px;
  }
  .sub-text {
    font-size: 14px;
    margin-bottom: 0px;
    padding: 0px 11px;
  }
  .midHeading {
    font-size: 14px;
  }
}
@media (max-width: 576px) {
  .candidateOffer .candidate_Details {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
  }
  .TopHeading h4 {
    font-size: 18px;
  }
  .midHeading {
    font-size: 14px;
  }
  .form-card {
    padding: 10px 8px;
  }
  .form-card h3 {
    margin-left: 8px;
    font-size: 1rem;
  }
  .answereArea {
    padding: 12px 10px;
  }
  .questions-table tbody tr.question-row {
    padding: 18px;
    margin-bottom: 14px;
  }
  .questions-table tr.question-row td {
    padding: 10px 1px;
  }
  .questions-table td::before {
    margin-bottom: 8px;
  }
  .questions-table td.answer-cell::before {
    margin-bottom: 10px;
  }
  .questions-table .save-cell .applyButton {
    width: 100%;
    max-width: 200px;
  }
  .row.m-3 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
  .common_button_sub button {
    width: 100%;
  }
  .table {
    border: 0 !important;
  }
}
/*# sourceMappingURL=candidate-form.component.css.map */
